import { useEffect, useState } from 'react';

type DeviceDetectorTypes = 'Small' | 'Mobile' | 'Large';

export const useDeviceDetector = () => {
    const [device, setDevice] = useState<DeviceDetectorTypes>('Large');

    const handleResize = () => {
        if (document.body.clientWidth) {
            if (document.body.clientWidth < 768) {
                setDevice('Small');
                return;
            }

            if (document.body.clientWidth < 1280) {
                setDevice('Mobile');
                return;
            }

            setDevice('Large');
        }
    };

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return device;
};
